import ServiceResponse from "../payload/response/ServiceResponse";
import apiClient from "./apiClient";
import AdvertResponse from "../payload/response/AdvertResponse";

export type AdvertSearchSortParams = {
  productId?: number;
  manufacturerId?: number;
  categoryId?: number;
  sortField?: string;
  sortDirection?: string;
  isActive?: boolean;
};

export const getAdverts = async (
  pageNumber: number,
  pageSize: number,
  params?: AdvertSearchSortParams
): Promise<ServiceResponse<AdvertResponse>> => {
  const body: any = {
    pageNumber,
    pageSize,
  };

  if (params?.productId) body.productId = params.productId;
  if (params?.manufacturerId) body.manufacturerId = params.manufacturerId;
  if (params?.categoryId) body.categoryId = params.categoryId;
  if (params?.sortField) body.sortField = params.sortField;
  if (params?.sortDirection) body.sortDirection = params.sortDirection;
  if (params?.isActive !== undefined) body.isActive = params.isActive;

  const response = await apiClient.post<ServiceResponse<AdvertResponse>>(
    `/api/advert/get-all-adverts-for-admin/${pageNumber}`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const updateAdvertStatus = async (
  advertId: number
): Promise<ServiceResponse<Boolean>> => {
  const response = await apiClient.put(
    `/api/advert/update-advert-status-for-admin/${advertId}`
  );
  return response.data;
};
export const deleteAdvert = async (
  advertId: number
): Promise<ServiceResponse<Boolean>> => {
  const response = await apiClient.delete(
    `/api/advert/delete-advert/${advertId}`
  );
  return response.data;
};
